import Config from "../config/settings";
import UserService from "./user";
import * as ionicFile from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';

class UpdateService {

    showDownload = false;
    showUpdateDownload = false;
    versionServer = null;
    versionInstalled = null;
    
    updateHasBeenChecked = false;

    async checkUpdate(userService: UserService) {
        const baseUrl = Config.debugMode ? Config.urlDebug : Config.url;
        const url = baseUrl + 'live-update?email=' + userService.email + '&security=' + userService.security + '&page=' + userService.isMarketPage + '&v=' + Config.version;
    
        if (Config.autoUpdateEnabled === false) {
            return false;
        }

        return fetch(url).then(async (res) => {
          const result = await res.json();
          
          const serverVersion = Number(result.msg);
          this.versionServer = result.msg;
          const installedVersion = Number(userService.version.replace('.', ''));
          this.versionInstalled = userService.version.replace('.', '');
    
          if (serverVersion > installedVersion) {
            this.showUpdateDownload = true;
          }

          return this.showUpdateDownload;
        });
    }


    updateApplication(userService: UserService) {
        console.log('Update confirmed');
        const baseUrl = Config.debugMode ? Config.urlDebug : Config.url;
        const urlApk = baseUrl + 'live-update-file?email=' + userService.email + '&security=' + userService.security + '&page=' + userService.isMarketPage + '&v=' + Config.version + '&update=' + this.versionServer;
        
        this.showDownload = true;
    
        fetch(urlApk).then(async (resApk) => {
          const apkBlob = await resApk.blob();
    
          console.log('go apk', this.versionServer, this.versionInstalled, apkBlob.size);
    
          // const file = new File([apkBlob], 'update.apk', {lastModified: new Date().getTime()});
    
          await ionicFile.File.writeFile(
            ionicFile.File.dataDirectory, 
            'update.apk', 
            apkBlob, 
            {
              replace: true,
            }
          ).then(async (file) => {
            console.log('file', file);

            await FileOpener.open(
              `${ionicFile.File.dataDirectory}/update.apk`,
              'application/vnd.android.package-archive'
            );
          });
        })
        .catch((error) => {
            this.showDownload = false;
            alert('Error during update, please contact support, thanks. ' + error);
        })
        .finally(() => {
          this.showDownload = false;
        });
    }
}

export default UpdateService;